import { withAuth } from '@/utilities/queries';
import { submitGiftCardPromoCode } from '@simplywallst/services';

export const submitPromoCode = async ({ promoCode }: { promoCode: string }) => {
  try {
    const response = await withAuth(submitGiftCardPromoCode, promoCode);
    return response.data.data;
  } catch (e) {
    throw e;
  }
};
